import { z } from 'zod';
import { EnumUtils } from '@colonist/utils';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { PlayerColor } from '../PlayerState.ts';
import { uniquePlayerColorsArraySchema } from '../SharedZodSchemas.ts';
import { validateState } from '../ValidateState.ts';
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const tradeEmbargoStateSchema = z.object({
    activeEmbargosAgainst: uniquePlayerColorsArraySchema.readonly()
}).strict();
export function validateTradeEmbargoState(data) {
    return validateState(tradeEmbargoStateSchema, data);
}
export const tradeEmbargoStatesSchema = createKeyRecordSchema(playerColorNumericKeys, tradeEmbargoStateSchema);
export function validateTradeEmbargoStates(data) {
    return validateState(tradeEmbargoStatesSchema, data);
}
export const tradeEmbargoStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(tradeEmbargoStateSchema);
export const tradeEmbargoStatesPartialSchema = createKeyRecordSchema(playerColorNumericKeys, tradeEmbargoStatePartialSchema, {
    requireAtLeastOneEntry: true
});
